module.exports = __webpack_public_path__ + "img/news_0.999991df.png";